module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_6.eb361c89.png";